import React from 'react';

const BlankPageView = () => {
    return (
        <div />
    );
};
export default BlankPageView;
